<template>
    <div class="cl_card">
        <div class="cl_card_img" :class="{'exercise_card_img':type==='exercise'}">
            <img
                :src="item.image || item.drawingThumbnail || require('@i/exercise/formation_bg.svg')"
                alt
            />
            <div class="cl_card_animation" v-if="item.videoUrl && item.videoSnapshot">
                <img src="@i/exercise/exercise_animation.svg" alt />
            </div>
        </div>
        <div class="cl_card_main">
            <div class="cl_card_avatar">
                <div>
                    <img :src="item.creatorAvatar" alt />
                </div>
            </div>
            <div class="cl_card_name">
                <div class="card_title SysFontM">{{item.name || item.title}}</div>
                <div class="card_name">
                    <slot :item="item">
                        <span class="Text_Over">{{item['creatorName'+$lang]}}</span>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/**
 * ComponentName: 卡片UI
 * Created Date:2022/5/6
 * Author: dongyu·zhu
 * Modify: shishuo·zhang 2022/5/10 | Nancy 2022/5/11
 * 组件说明：
 * eg:
 * <cl-card></cl-card>
 */
export default {
    name: "cl-card",
    props: {
        item: {
            type: Object,
            default: () => { }
        },
        type: { // 卡片类型: 阵型formation || 教案exercise
            type: String,
            default: 'formation'
        }

    },

    data () {
        return {

        };
    }
}
</script>
<style lang="scss" scoped>
.cl_card {
    width: 172px;
    height: 287px;
    border-radius: 6px;
    overflow: hidden;
    color: #3a3a3a;
    filter: drop-shadow(0px 16px 16px rgba(129, 129, 138, 0.08));
    display: flex;
    flex-direction: column;
    cursor: pointer;
    position: relative;
    &::before {
        content: ' ';
        display: none;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 140px;
        height: 4px;
        background-color: $base-color-theme;
        border-radius: 5px 5px 0 0;
        z-index: 3;
    }
    &_img {
        width: 100%;
        height: 227px;
        transition: all 0.3s;
        position: relative;
        img {
            width: 100%;
            height: 230px;
        }
    }

    &_main {
        width: 100%;
        flex: 1;
        position: relative;
    }
    &_avatar {
        width: 44px;
        height: 42px;
        position: absolute;
        right: -1px;
        top: -41px;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        background-image: url(~@i/exercise/creator-bg.svg);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding-right: 2px;
        box-sizing: border-box;
        div {
            width: 24px;
            height: 24px;
            overflow: hidden;
            border-radius: 50%;
            img {
                width: 100%;
            }
        }
    }
    &_name {
        height: 100%;
        padding: 10px 12px;
        box-sizing: border-box;
        background-color: #fff;
        border: 1px solid #f3f5f9;
        border-top: 0px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 14px;
        border-radius: 0 0 6px 6px;
    }
    &_animation {
        position: absolute;
        height: 22px;
        width: 22px;
        background: rgba($color: #000000, $alpha: 0.16);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        bottom: 6px;
        left: 6px;
        img {
            height: 14px;
        }
    }
    .card_title {
        overflow: hidden;
        text-overflow: ellipsis; /* 弹性伸缩盒子模型显示 */
        display: -webkit-box; /* 限制在一个块元素显示的文本的行数 */
        -webkit-line-clamp: 2; /* 设置或检索伸缩盒对象的子元素的排列方式 */
        -webkit-box-orient: vertical;
        font-size: 14px;
        line-height: 20px;
        color: #3a3a3a;
    }
    .card_name {
        display: none;
        color: #afafaf;
        font-size: 14px;
        line-height: 17px;
    }
    &:hover {
        .cl_card_img {
            transition: all 0.3s;
            height: 200px;
            &.exercise_card_img {
                height: 171px;
            }
        }
        .cl_card_animation {
            background: #3663e1;
        }
        .card_name {
            display: block;
        }
        &::before {
            content: ' ';
            display: block;
        }
    }
}
</style>